module.exports = __webpack_public_path__ + "img/icon8.67d80839.jpg";